<div class="page">

  <div class="pagehead">
    <div>
      <h1>Airtel CMS</h1>
      <p>Setting up your Airtel session</p>
    </div>
  </div>

  <div class="card handoff">
    <div class="clabel"><svg viewBox="0 0 24 24"><path d="M13 3L4 14h6l-1 7 9-11h-6l1-7z"/></svg>Opening Airtel CMS</div>
    <p class="handoff-copy">
      We're preparing your Airtel CMS session — it opens in a new tab automatically.
      If your browser asks for location access, allow it; Airtel requires your outlet's location.
    </p>
    <p class="handoff-hint">You'll be returned to the dashboard once the session opens.</p>
  </div>

</div>
